import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';

// eslint-disable-next-line import/prefer-default-export
export const openRouteOverviewTreeDialog = ({ treeList, routeName, projectId, routeId }) =>
  updateDialog({
    id: typeOfRouteOverviewTreeDialog,
    typeOfRouteOverviewTreeDialog,
    dialogType: typeOfRouteOverviewTreeDialog,
    treeList,
    routeName,
    projectId,
    routeId,
  });
